import React from 'react';
import {useStores} from "../../../stores/Context";

const WidgetTableauBlancBtn = ({children}) => {
    const {TableauBlancStore, uiStore} = useStores();


    const handleGoHome = () => {
        uiStore.closeConsultingMode();
    }

    return (
        <div className={"navBarWidgetBtnContent"}>
            <>
                <div className={"widgetsNavBarContentIcons"} onClick={() => handleGoHome()}>
                    <svg style={{width: "3em"}} viewBox="0 0 40 40" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.69144 31.0563C1.86301 31.0563 1.19144 31.7278 1.19144 32.5563C1.19144 33.3847 1.86301 34.0563 2.69144 34.0563V31.0563ZM7.79717 12.9393C7.21138 13.5251 7.21138 14.4749 7.79717 15.0607L17.3431 24.6066C17.9289 25.1924 18.8786 25.1924 19.4644 24.6066C20.0502 24.0208 20.0502 23.0711 19.4644 22.4853L10.9791 14L19.4644 5.51472C20.0502 4.92893 20.0502 3.97919 19.4644 3.3934C18.8786 2.80761 17.9289 2.80761 17.3431 3.3934L7.79717 12.9393ZM2.69144 34.0563H27.5704V31.0563H2.69144V34.0563ZM27.5704 34.0563C33.46 34.0563 38.1914 29.2061 38.1914 23.2781H35.1914C35.1914 27.5978 31.755 31.0563 27.5704 31.0563V34.0563ZM38.1914 23.2781C38.1914 17.3501 33.46 12.5 27.5704 12.5V15.5C31.755 15.5 35.1914 18.9584 35.1914 23.2781H38.1914ZM27.5704 12.5H8.85783V15.5H27.5704V12.5Z"
                            fill="#FBFDFE"/>
                    </svg>
                    <span className={"widgetsNavBarContentIconsText"}>Revenir</span>
                </div>

                {(TableauBlancStore.idCanvas) && (
                    <div className={"widgetsNavBarContentIcons"} onClick={() => TableauBlancStore.idCanvas = null}>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4 3C3.4375 3 3 3.5 3 4V24C3 24.5625 3.4375 25 4 25H24C24.5 25 25 24.5625 25 24V4C25 3.5 24.5 3 24 3H4ZM0 4C0 1.8125 1.75 0 4 0H24C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H4C1.75 28 0 26.25 0 24V4ZM6 8C6 6.9375 6.875 6 8 6C9.0625 6 10 6.9375 10 8C10 9.125 9.0625 10 8 10C6.875 10 6 9.125 6 8ZM12.5 8C12.5 7.1875 13.125 6.5 14 6.5H20C20.8125 6.5 21.5 7.1875 21.5 8C21.5 8.875 20.8125 9.5 20 9.5H14C13.125 9.5 12.5 8.875 12.5 8ZM12.5 14C12.5 13.1875 13.125 12.5 14 12.5H20C20.8125 12.5 21.5 13.1875 21.5 14C21.5 14.875 20.8125 15.5 20 15.5H14C13.125 15.5 12.5 14.875 12.5 14ZM12.5 20C12.5 19.1875 13.125 18.5 14 18.5H20C20.8125 18.5 21.5 19.1875 21.5 20C21.5 20.875 20.8125 21.5 20 21.5H14C13.125 21.5 12.5 20.875 12.5 20ZM8 16C6.875 16 6 15.125 6 14C6 12.9375 6.875 12 8 12C9.0625 12 10 12.9375 10 14C10 15.125 9.0625 16 8 16ZM6 20C6 18.9375 6.875 18 8 18C9.0625 18 10 18.9375 10 20C10 21.125 9.0625 22 8 22C6.875 22 6 21.125 6 20Z"
                                fill="#FBFDFE"/>
                        </svg>

                        <span className={"widgetsNavBarContentIconsText"}>Liste des tableaux</span>
                    </div>
                )}


                {children}
            </>
        </div>
    );
};

export default WidgetTableauBlancBtn;